import { Component, ElementRef, OnInit } from '@angular/core';


import {AfterViewInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}
/** Constants used to fill up our data base. */
const COLORS: string[] = [
  'maroon', 'red', 'orange', 'yellow', 'olive', 'green', 'purple', 'fuchsia', 'lime', 'teal',
  'aqua', 'blue', 'navy', 'black', 'gray'
];
const NAMES: string[] = [
  'Maia', 'Asher', 'Olivia', 'Atticus', 'Amelia', 'Jack', 'Charlotte', 'Theodore', 'Isla', 'Oliver',
  'Isabella', 'Jasper', 'Cora', 'Levi', 'Violet', 'Arthur', 'Mia', 'Thomas', 'Elizabeth'
];

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.scss']
})

export class OrganisationComponent implements OnInit {

  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  is_active='1';
  organisationData:any;
  adminData:any;
  searchText = "";
  //user_status = "2";
  order_by = "created_dttm";
  order = "DESC";
  filter_by: any = "";

  tabName: any = ''; user_id: any = '';
  organisation_id: any;
  @ViewChild('searchOrg', {static:true})searchOrg:ElementRef | undefined
  constructor(private contentAuthoringApi:ContentAuthoringService,private modalService: NgbModal, private router: Router,) { }

  ngOnInit(): void {
   // this.getOrganisationList(this.is_active);
   this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.getOrganisationList(this.searchText, this.is_active, this.order_by, this.order);
    fromEvent(this.searchOrg?.nativeElement, 'keyup').pipe(
      map((e:any)=> e?.target.value),debounceTime(1000)
    ).subscribe((res:any)=>{
      this.searchText=res
      this.getOrganisationList(this.searchText, this.is_active, this.order_by, this.order);
    })
  }
  getOrganisationList(searchText:any, is_active:any, order_by:any, order:any){
    this.contentAuthoringApi.getOrganisationList(searchText,is_active, order_by, order).subscribe(
      (data)=>{
        console.log(data);
      if(data.success){
        this.organisationData= data.organisationList;
      }else{
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = 'No data Exist';
      }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
       },
    );
  }

  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
    this.getOrganisationList(this.searchText, this.is_active, this.order_by, this.order);
  }
   /*******get active and deactive data of organization */
   onSelectChange(event: any) {
    if (event.index == 1) { //deactive
      this.is_active = '0';
    } else {
      this.is_active = '1'; //active
    }
    this.getOrganisationList(this.searchText, this.is_active, this.order_by, this.order);
  }

  open(content: any, organisation_id: any, tab_name: any) {
    this.tabName = tab_name;
    this.organisation_id = organisation_id;
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  changeIsDeActiveVal(organisation_id: any, is_actives: any) {
    this.changeIsActiveVal(organisation_id, is_actives);
  }
  changeIsActiveVal(organisation_id: any, is_active: any) {
    console.log(organisation_id,is_active);
    this.contentAuthoringApi.changeOrgIsActiveVal(organisation_id, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getOrganisationList(this.searchText, this.is_active, this.order_by, this.order);
          // this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
   }
   logout() {
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  edit(org_id:any){
    this.router.navigate(['/organisation_create'], { queryParams: {id:org_id, type:1 } });

  }
  deleteOrganisation(org_id: any) {
    this.contentAuthoringApi.deletesOrg(org_id).subscribe(
      (data) => {
        console.log(data);
        if (data.Status == 200) {
          document.getElementById('closelId')?.click();
          this.getOrganisationList(this.searchText, this.is_active, this.order_by, this.order);
          this.router.navigate(['/organisation']);
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }
}



